import get from 'lodash/get';
import { isValidEmail } from '../../lib/validators';
import { errPasswordIncorrect, errEmailNonUnique, errEmailNotFound } from '../../lib/userApi';


export const token = state => state.auth.token;

export const password = state => state.auth.password;
export const passwordConfirm = state => state.auth.passwordConfirm;

export const user = state => state.user;
export const accountForm = state => state.accountForm;

export const loginFormValidations = state => ({
  email: isValidEmail(state.user.email),
  password: get(state.auth, 'password', '').length > 2,
});
export const loginFormErrors = state => ({
  errEmailNotFound: get(state.errors, 'loginForm', []).some(err => err.code === errEmailNotFound),
  errPasswordIncorrect: get(state.errors, 'loginForm', []).some(err => err.code === errPasswordIncorrect),
});

export const signupFormValidations = state => ({
  email: isValidEmail(state.user.email),
  password: get(state.auth, 'password', '').length > 2,
  passwordConfirm: get(state.auth, 'password', '').length > 2 && state.auth.password === state.auth.passwordConfirm,
  firstName: get(state.user, 'firstName', '').length > 2,
  agreedToTermsAndConditions: !isNaN(new Date(state.ui.agreedToTermsAndConditions).getTime()),
});
export const signupFormErrors = state => ({
  errEmailNonUnique: get(state.errors, 'signupForm', []).some(err => err.code === errEmailNonUnique),
});

export const accountFormValidations = state => ({
  email: isValidEmail(state.accountForm.email),
  firstName: get(state.accountForm, 'firstName', '').length > 2,
  descriptionMD: get(state.accountForm, 'descriptionMD', '').length < 2000,
});
export const accountFormErrors = state => ({
  errEmailNonUnique: get(state.errors, 'accountForm', []).some(err => err.code === errEmailNonUnique),
  errPasswordIncorrect: get(state.errors, 'accountForm', []).some(err => err.code === errPasswordIncorrect),

  email: get(state.errors, 'accountForm', []).some(err => err.field === 'user.email'),
  website: get(state.errors, 'accountForm', []).some(err => err.field === 'user.socialLinks.website'),
  facebook: get(state.errors, 'accountForm', []).some(err => err.field === 'user.socialLinks.facebook'),
  linkedin: get(state.errors, 'accountForm', []).some(err => err.field === 'user.socialLinks.linkedin'),
});
